import React from 'react';
import EmptyFaceIcon from '@/assets/icons/EmptyFaceIcon.svg?react';
import { Button } from '@/components/V3/Button';

interface NewsErrorFallbackProps {
  onRetry: () => void;
  isLoading: boolean;
}

export const NewsErrorFallback: React.FC<NewsErrorFallbackProps> = ({ onRetry, isLoading }) => {
  return (
    <div className="flex h-[100dvh] w-full items-center justify-center bg-gr-50 px-[20px]">
      <div className="my-[40px] flex w-full flex-col items-center gap-[20px]">
        <span>
          <EmptyFaceIcon />
        </span>
        <div className="BodyM14">콘텐츠를 불러오는 데 문제가 발생했습니다.</div>
        <Button onClick={onRetry} variant={'SolidLow'} height={'44'} width={'10'}>
          {isLoading ? (
            <span className="flex items-center justify-center gap-2">
              <span className="h-4 w-4 animate-spin rounded-full border-2 border-black border-t-transparent" />
              불러오는 중...
            </span>
          ) : (
            '다시 시도'
          )}
        </Button>
      </div>
    </div>
  );
};
